import React from "react";
import { Modal } from "antd";

import CustomButton from "../customButton";
import "./styles.scss";

function CustomModal(props) {
  const {
    title,
    isVisible,
    isDelete,
    handleCancel,
    cancelButtonText,
    disabled,
    handleDelete,
    submitButtonText,
    customClass,
    cancelDisabled = false,
    loading = false,
  } = props;

  return (
    <div>
      <Modal
        data-testid="custom-modal-id"
        className={`custom-modal ${customClass}`}
        title={title}
        mask={false}
        visible={isVisible}
        centered
        footer={[
          <CustomButton
            className={`cancel-button ${isDelete && "danger-button"}`}
            onClick={handleCancel}
            title={cancelButtonText}
            key="cancel"
            disabled={cancelDisabled}
          />,
          <CustomButton
            className={disabled ? "disable-button" : ""}
            htmlType="submit"
            type="primary"
            onClick={handleDelete}
            title={submitButtonText}
            key="submit"
            disabled={disabled}
            loading={loading}
          />,
        ]}
      >
        {props.children}
      </Modal>
    </div>
  );
}

export default CustomModal;
